var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOtp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 91,
    viewBox: "0 0 91 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45.5,
    cy: 45.3312,
    r: 45.3312,
    fill: "#E8F7ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M36.8772 58.3924L31.1051 63.2447C30.9001 63.417 30.6502 63.5272 30.3847 63.5623C30.1192 63.5975 29.8492 63.5561 29.6065 63.443C29.3637 63.3299 29.1583 63.1499 29.0143 62.9241C28.8704 62.6983 28.7939 62.436 28.7939 62.1682V34.25C28.7939 33.877 28.9421 33.5194 29.2058 33.2556C29.4695 32.9919 29.8272 32.8438 30.2002 32.8438H61.1377C61.5107 32.8438 61.8683 32.9919 62.1321 33.2556C62.3958 33.5194 62.5439 33.877 62.5439 34.25V56.75C62.5439 57.123 62.3958 57.4806 62.1321 57.7444C61.8683 58.0081 61.5107 58.1562 61.1377 58.1562H37.5252L36.8772 58.3924Z",
    fill: "#4FAF5A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8772 58.3924L31.1051 63.2447C30.9001 63.417 30.6502 63.5272 30.3847 63.5623C30.1192 63.5975 29.8492 63.5561 29.6065 63.443C29.3637 63.3299 29.1583 63.1499 29.0143 62.9241C28.8704 62.6983 28.7939 62.436 28.7939 62.1682V34.25C28.7939 33.877 28.9421 33.5194 29.2058 33.2556C29.4695 32.9919 29.8272 32.8438 30.2002 32.8438H61.1377C61.5107 32.8438 61.8683 32.9919 62.1321 33.2556C62.3958 33.5194 62.5439 33.877 62.5439 34.25V56.75C62.5439 57.123 62.3958 57.4806 62.1321 57.7444C61.8683 58.0081 61.5107 58.1562 61.1377 58.1562H37.5252L36.8772 58.3924Z",
    stroke: "#4FAF5A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0439 42.6875H51.2939",
    stroke: "#4FAF5A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0439 48.3125H51.2939",
    stroke: "#4FAF5A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtp);
export default __webpack_public_path__ + "static/media/Otp.b1898dcf15cb5e149d364761373d402a.svg";
export { ForwardRef as ReactComponent };